export default __webpack_public_path__ + "static/media/general.a9235321.png";